export const DEFAULT_BASE_URL = `${window.location.origin}${window.location.pathname}#`